<script lang="ts">
    import type { SVGAttributes } from "svelte/elements";

    interface $$Props extends SVGAttributes<SVGSVGElement>{
        strokeWidth?: number
    }
    export let strokeWidth: $$Props["strokeWidth"] = 2
</script>

<svg viewBox="0 0 18 105" {...$$restProps}>
    <line x1=9 x2=9 y1=0 y2="105" stroke="currentColor" stroke-width={strokeWidth} stroke-dasharray="12 6"/>
</svg>